import { Backdrop, Box, CircularProgress } from '@mui/material';
import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { numberFormatting, separateObjectsByYear } from '../../services/Functions';
import { cfpBaseUrl } from '../../network/urls';
import { updatePerformance } from '../../features/dashboard/overallPerformance';
const CollectionLossCard = React.lazy(() => import('../../components/collectionLossCard/CollectionLossCard'));
const ComplaintsCard = React.lazy(() => import('../../components/complaintsCard/ComplaintsCard'));
const ConsumerBase = React.lazy(() => import('../../components/consumerBase/ConsumerBase'));
const CurrentCollectionDashboard = React.lazy(() => import('../../components/currentCollectionChart/CurrentCollectionChart'));
const ServicesTable = React.lazy(() => import('../../components/servicesTable/ServicesTable'));
const TechnicalAndCommercial = React.lazy(() => import('../../components/technicalAndCommercial/TechnicalAndCommercial'));
const TechnicalLossCard = React.lazy(() => import('../../components/technicalLossCard/TechnicalLossCard'));
const CurrentBillingChart = React.lazy(() => import('../../components/currentBillingChart/CurrentBillingChart')); // Adjust the path based on your project structure

const FieldOfficeDashboard = () => {
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch()
    let officeCode = location.state?.officeCode.toString() || '15171'; // Provide a default value if needed
    officeCode = officeCode == "10" ? "15" : officeCode
    const { token, hierarchy } = useSelector((state) => state.auth)

    //#region states
    const [technicalCommercial, setTechnicalCommercial] = useState([
        {
            titleA: 'T & D',
            titleB: 'Monthly',
            value: -18.6,
            type: 'losses',
            incDec: 'positive'
        },
        {
            titleA: 'T & D',
            titleB: 'Progressive',
            value: -8.7,
            type: 'losses',
            incDec: 'negetive'
        },
        {
            titleA: 'Recovery',
            titleB: 'Monthly',
            value: -93.4,
            type: 'losses',
            incDec: 'positive'
        },
        {
            titleA: 'Recovery',
            titleB: 'Progressive',
            value: 94,
            type: 'losses',
            incDec: 'negetive'
        },
        {
            titleA: 'AT & C',
            titleB: 'Monthly',
            value: 18.3,
            type: 'losses',
            incDec: 'positive'
        },
        {
            titleA: 'AT & C',
            titleB: 'Progressive',
            value: -8.6,
            type: 'losses',
            incDec: 'positive'
        },
    ])

    const [tDMonthlyLossData, setTDMonthlyLossData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [tDProgressiveLossData, setTDProgressiveLossData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [tDMonthlyLossDifferenceData, setTDMonthlyLossDifferenceData] = useState([])
    const [tDProgressiveLossDifferenceData, setTDProgressiveLossDifferenceData] = useState([])
    const [recoveryMonthlyData, setRecoveryMonthlyData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [recoveryProgressiveData, setRecoveryProgressiveData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [recoveryMonthlyDifferenceData, setRecoveryMonthlyDifferenceData] = useState([]);
    const [recoveryProgressiveDifferenceData, setRecoveryProgressiveDifferenceData] = useState([]);
    const [aTCMonthlyData, setATCMonthlyData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [aTCProgressiveData, setATCProgressiveData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [aTCMonthlyDifferenceData, setATCMonthlyDifferenceData] = useState([])
    const [aTCProgressiveDifferenceData, setATCProgressiveDifferenceData] = useState([])
    const [tDMonthlyChart, setTDMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0,
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        tooltip: {
            pointFormat: ' {series.name}: <b>{point.y}%</b>'
        },
        colors: [ // Custom colors for the pie slices
            '#FD8A8A', // Slice 2 color
            '#FF3131', // Slice 1 color
            // Add more colors as needed
        ],
        yAxis: {
            title: {
                text: 'T & D Loss (%age)'
            }
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }]
    })
    const [tDProgressiveChart, setTDProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: ' transparent',
            height: 300,
            padding: 0,
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        yAxis: {
            title: {
                text: 'T & D Loss (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#FD8A8A', // Slice 2 color
            '#FF3131', // Slice 1 color
            // Add more colors as needed
        ],
    })
    const [recoveryMonthlyChart, setRecoveryMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        colors: [ // Custom colors for the pie slices
            '#88D6B5', // Slice 1 color
            '#12AE6C', // Slice 2 color
            // Add more colors as needed
        ],
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        yAxis: {
            title: {
                text: 'Recovery (%age)'
            }
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }]
    })
    const [recoveryProgressiveChart, setRecoveryProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        yAxis: {
            title: {
                text: 'Recovery (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#88D6B5', // Slice 1 color
            '#12AE6C', // Slice 2 color
            // Add more colors as needed
        ],
    })
    const [aTCMonthlyChart, setATCMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        yAxis: {
            title: {
                text: 'AT & C Loss (%age)'
            }
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }],
        colors: [ // Custom colors for the pie slices
            '#F6D3A9', // Slice 2 color
            '#FFC03D', // Slice 1 color
            // Add more colors as needed
        ],
    })
    const [aTCProgressiveChart, setATCProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        yAxis: {
            title: {
                text: 'AT & C Loss (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#F6D3A9', // Slice 2 color
            '#FFC03D', // Slice 1 color
            // Add more colors as needed
        ],
    })

    //#endregion

    //#region functions

    const MonthlyTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        if (separateYearData.firstYear) {
                            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        }
                        if (separateYearData.secondYear) {
                            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                                const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        }

                        setTDMonthlyLossData(separateYearData)
                        let incDec = []
                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }
                        setTDMonthlyLossDifferenceData(incDec)
                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];
                        const updatedTDMonthlyChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };
                        setTDMonthlyChart(updatedTDMonthlyChart);
                        let index = incDec.length - 1
                        let aggregateTDMonthly = 0

                        if (incDec.length > 1) {
                            aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[0] = {
                                ...newState[0],
                                value: aggregateTDMonthly
                            }
                            return newState;
                        })
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        setTDProgressiveLossData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setTDProgressiveLossDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];

                        const updatedTDProgressiveChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setTDProgressiveChart(updatedTDProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateTDProgressive = 0
                        if (incDec.length > 1) {
                            aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[0] = {
                                ...newState[1],
                                value: aggregateTDProgressive
                            }
                            return newState;
                        })
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };
                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryMonthlyChart = {
                            ...recoveryMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryMonthly = 0

                        if (incDec.length > 1) {
                            aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[2] = {
                                ...newState[2],
                                value: aggregateRecoveryMonthly
                            }
                            return newState;
                        })
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic 
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryProgressiveChart = {
                            ...recoveryProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryProgressive = 0;
                        if (incDec.length > 1) {
                            aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[3] = {
                                ...newState[3],
                                value: aggregateRecoveryProgressive
                            }
                            return newState;
                        })

                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyATCDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCMonthlyChart = {
                            ...aTCMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCMonthlyChart(updatedATCMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateATCMonthly = 0

                        if (incDec.length > 1) {
                            aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[4] = {
                                ...newState[4],
                                value: aggregateATCMonthly
                            }
                            return newState;
                        })
                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveATCDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)

                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCProgressiveChart = {
                            ...aTCProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCProgressiveChart(updatedATCProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateATCProgressive = 0

                        if (incDec.length > 1) {
                            aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setTechnicalCommercial(prevState => {
                            const newState = [...prevState];
                            newState[5] = {
                                ...newState[5],
                                value: aggregateATCProgressive
                            }
                            return newState;
                        })

                        dispatch(updatePerformance(aggregateATCProgressive))

                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    //#endregion

    //#region useEffects
    useEffect(() => {
        setViewBackdrop(true)
        const fetchData = async () => {
            try {
                //#region Technical & Commercial 
                await MonthlyTDLossesDashboardStats(token, officeCode, hierarchy);
                await ProgressiveTDLossesDashboardStats(token, officeCode, hierarchy)
                await MonthlyRecoveryDashboardStats(token, officeCode, hierarchy)
                await ProgressiveRecoveryDashboardStats(token, officeCode, hierarchy)
                await MonthlyATCDashboardStats(token, officeCode, hierarchy)
                await ProgressiveATCDashboardStats(token, officeCode, hierarchy)
                //#endregion
            } catch (error) {
                console.error('Error in useLayoutEffect:', error);
            }
            setViewBackdrop(false)
        }
        fetchData()
    }, [])
    //#endregion

    return (
        <>
            <Box className="form-box">
                <div className='cfc-dashboard' style={{ flexDirection: 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <Suspense fallback={<div>Loading ... </div>}>
                            <ConsumerBase officeCode={officeCode} showTechnicalCommercial={false} />
                        </Suspense>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            <Suspense fallback={<div>Loading ... </div>}>
                                <ComplaintsCard officeCode={officeCode} />
                            </Suspense>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <Suspense fallback={<div>Loading ... </div>}>
                                    <TechnicalLossCard officeCode={officeCode} />
                                </Suspense>
                                <Suspense fallback={<div>Loading ... </div>}>
                                    <CollectionLossCard officeCode={officeCode} />
                                </Suspense>
                            </div>
                        </div>
                        <Suspense fallback={<div>Loading card...</div>}>
                            <ServicesTable officeCode={officeCode} />
                        </Suspense>
                    </div>
                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Suspense fallback={<div>Loading ... </div>}>
                                <TechnicalAndCommercial
                                    technicalCommercialprop={technicalCommercial}
                                    tDMonthlyLossData={tDMonthlyLossData}
                                    tDMonthlyChart={tDMonthlyChart}
                                    tDMonthlyLossDifferenceData={tDMonthlyLossDifferenceData}
                                    tDProgressiveLossData={tDProgressiveLossData}
                                    tDProgressiveChart={tDProgressiveChart}
                                    tDProgressiveLossDifferenceData={tDProgressiveLossDifferenceData}
                                    recoveryMonthlyData={recoveryMonthlyData}
                                    recoveryMonthlyChart={recoveryMonthlyChart}
                                    recoveryMonthlyDifferenceData={recoveryMonthlyDifferenceData}
                                    recoveryProgressiveData={recoveryProgressiveData}
                                    recoveryProgressiveChart={recoveryProgressiveChart}
                                    recoveryProgressiveDifferenceData={recoveryProgressiveDifferenceData}
                                    aTCMonthlyData={aTCMonthlyData}
                                    aTCMonthlyChart={aTCMonthlyChart}
                                    aTCMonthlyDifferenceData={aTCMonthlyDifferenceData}
                                    aTCProgressiveData={aTCProgressiveData}
                                    aTCProgressiveChart={aTCProgressiveChart}
                                    aTCProgressiveDifferenceData={aTCProgressiveDifferenceData}
                                />
                            </Suspense>
                            <Suspense fallback={<div>Loading ... </div>}>
                                <CurrentBillingChart officeCode={officeCode} />
                            </Suspense>
                            <Suspense fallback={<div>Loading ... </div>}>
                                <CurrentCollectionDashboard officeCode={officeCode} />
                            </Suspense>
                        </div>
                    </div>
                </div>
            </Box>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default FieldOfficeDashboard